import { InfoOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  Input,
} from "@mui/joy";
import { validatePassword } from "app/utils";
import React from "react";

type Props = {
  value?: string;
  onChange?: (params?: any) => Promise<void> | void;
  getErrMessage?: (params?: any) => void;
  useConfirmPassword?: boolean;
};

const passwordMessageValidation =
  "Password must be at least 8 characters with uppercase, lowercase, and numbers";

const InputPassword = ({
  value,
  onChange,
  useConfirmPassword,
  getErrMessage,
}: Props) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [passValue, setPassValue] = React.useState("");
  const [confirmPassValue, setConfirmPassValue] = React.useState("");
  const [errMessage, setErrMessage] = React.useState("");
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [isValid, setIsValid] = React.useState(false);
  const [isTouched, setIsTouched] = React.useState(false);
  const [isConfirmPassTouched, setIsConfirmPassTouched] = React.useState(false);

  React.useEffect(() => {
    if (getErrMessage) {
      // Check if both the password is valid AND there's no error message about matching passwords
      const passwordIsValid = isValid && !errMessage;
      // console.log("InputPassword - calling getErrMessage with:", {
      //   isValid,
      //   errMessage,
      //   isConfirmPassTouched,
      //   passwordIsValid,
      // });
      getErrMessage(!passwordIsValid); // Sending the error state, not the message
    }
  }, [errMessage, isValid, isConfirmPassTouched, getErrMessage]);

  React.useEffect(() => {
    checkPassword(confirmPassValue);
  }, [passValue]);

  const checkPassword = (val: string) => {
    setConfirmPassValue(val);
    if (passValue !== val) {
      setErrMessage("Password does not match");
    } else {
      setErrMessage("");
    }
  };

  return (
    <>
      <FormControl required error={isTouched && !isValid}>
        <FormLabel>Password</FormLabel>
        <Input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Password"
          value={value}
          onChange={async (e) => {
            setPassValue(e.target.value);
            const isPassValid = validatePassword(e.target.value);
            setIsValid(isPassValid);

            if (!isPassValid) {
              setErrMessage(passwordMessageValidation);
            }

            if (onChange) {
              await onChange(e);
            }
          }}
          onBlur={() => setIsTouched(true)}
          endDecorator={
            <IconButton onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          }
        />
        <FormHelperText>
          <InfoOutlined sx={{ mr: 0.5, fontSize: "0.8rem" }} />
          {passwordMessageValidation}
        </FormHelperText>
      </FormControl>
      {useConfirmPassword && (
        <FormControl
          required
          error={Boolean(isConfirmPassTouched && errMessage)}
        >
          <FormLabel>Confirm Password</FormLabel>
          <Input
            type={showConfirmPassword ? "text" : "password"}
            name="password"
            placeholder="Confirm Password"
            onChange={(e) => checkPassword(e.target.value)}
            onBlur={() => setIsConfirmPassTouched(true)}
            endDecorator={
              <IconButton
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            }
          />
          {isConfirmPassTouched && errMessage && (
            <FormHelperText>
              <InfoOutlined />
              {errMessage}
            </FormHelperText>
          )}
        </FormControl>
      )}
    </>
  );
};

export default InputPassword;
